import React, { useEffect, useState } from "react";
import { Alert, Card, Descriptions, Table, Tag, Space, Spin } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";

interface SendStepProps {
  form: any;
  application: any;
  loading: boolean;
  formChangeId: number;
}

const DENIAL_REASON_LABELS: Record<string, string> = {
  credit_criminal: "Credit & Criminal",
  eviction: "Eviction",
  income: "Income",
  conditional_approval: "Conditional Approval",
};

const Send: React.FC<SendStepProps> = ({
  form,
  application,
  loading,
  formChangeId,
}) => {
  const [formValues, setFormValues] = useState<any>({
    denialReason: "",
    selectedApplicants: [],
    conditionalDepositAmount: "",
  });

  useEffect(() => {
    const denialReason = form.getFieldValue("denialReason") || "";
    const selectedApplicants = form.getFieldValue("selectedApplicants") || [];
    const conditionalDepositAmount =
      form.getFieldValue("conditionalDepositAmount") || "";

    setFormValues({
      denialReason,
      selectedApplicants,
      conditionalDepositAmount,
    });
  }, [formChangeId, form]);

  const recipientColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_: any, record: any) =>
        `${record.first_name} ${record.last_name}`,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
  ];

  const recipientData = formValues.selectedApplicants.map((a: any) => ({
    key: a.user_id,
    ...a,
  }));

  return (
    <div style={{ padding: "24px 0" }}>
      <Alert
        message="Review Before Sending"
        description="Please review the details below. Once sent, adverse action letters will be delivered to all recipients and the application will be marked as denied."
        type="info"
        showIcon
        style={{ marginBottom: 24 }}
      />

      <Space direction="vertical" style={{ width: "100%" }} size="large">
        <Card title="Denial Details" size="small">
          <Descriptions column={1} size="small">
            <Descriptions.Item label="Denial Reason">
              <Tag color="blue">
                {DENIAL_REASON_LABELS[formValues.denialReason] ||
                  formValues.denialReason}
              </Tag>
            </Descriptions.Item>
            {formValues.denialReason === "conditional_approval" && (
              <Descriptions.Item label="Required Additional Deposit">
                <Tag color="gold">
                  ${parseFloat(formValues.conditionalDepositAmount).toFixed(2)}
                </Tag>
              </Descriptions.Item>
            )}
            <Descriptions.Item label="Property">
              {application?.property_name}
            </Descriptions.Item>
          </Descriptions>
        </Card>

        <Card title="Recipients" size="small">
          <div style={{ marginBottom: 16 }}>
            <p style={{ color: "#666", fontSize: "14px" }}>
              <CheckCircleOutlined
                style={{ marginRight: 8, color: "#52c41a" }}
              />
              Adverse action letters will be sent to{" "}
              {formValues.selectedApplicants.length}{" "}
              {formValues.selectedApplicants.length === 1
                ? "applicant"
                : "applicants"}
            </p>
          </div>
          <Table
            columns={recipientColumns}
            dataSource={recipientData}
            pagination={false}
            size="small"
            bordered
          />
        </Card>
      </Space>
    </div>
  );
};

export default Send;